import PopupBasic from 'src/game/components/popups/PopupBasic';
import View from '@play-co/timestep-core/lib/ui/View';
import sounds from 'src/lib/sounds';
import { createEmitter } from 'src/lib/Emitter';
import { FlexBoxView } from '@play-co/timestep-core/flexbox';
import ButtonScaleView from 'src/lib/ui/components/ButtonScaleView';
import { ImageScaleView, animate } from '@play-co/timestep-core/ui';
import { animDuration } from 'src/lib/utils';
import { EmoteID, chatEmoteIDs } from 'src/replicant/team/team.ruleset';
import { Feature } from 'src/replicant/analytics';
import uiConfig from 'src/lib/ui/config';

import { AssetGroup } from '@play-co/timestep-core';

type CloseHandler = (result: EmoteID | undefined) => void;

const PANEL_HEIGHT = 300;
export default class PopupTeamChatEmotes extends PopupBasic {
  private panel: ImageScaleView;
  constructor(opts: { superview: View; close: CloseHandler }) {
    super({
      ...opts,
      close: () => opts.close(undefined),
      zIndex: 10001,
      width: 556,
      height: 455,
      tracking: {
        feature: Feature.MATCH2.TEAM._,
        $subFeature: Feature.MATCH2.TEAM.POPUP_EMOTES,
      },
      skipTitle: true,
      closeableWithBg: true,
    });

    this.box.removeFromSuperview();

    this.panel = new ImageScaleView({
      superview: this.root,
      width: uiConfig.width,
      height: PANEL_HEIGHT,
      image: 'assets/ui/match2/team/chat/panel_emoteBar.png',
      scaleMethod: '9slice',
      sourceSlices: {
        horizontal: { left: 2, right: 2 },
        vertical: { top: 8, bottom: 2 },
      },
    });

    const container = new FlexBoxView({
      superview: this.panel,
      height: 300,
      width: 160 * 4,
      centerOnOrigin: true,
      x: uiConfig.width / 2,
      y: this.panel.style.height / 2 - 10,
      flex: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignContent: 'center',
        flexWrap: 'wrap',
      },
    });

    for (let emoteId of chatEmoteIDs) {
      const button = new ButtonScaleView({
        superview: container,
        width: 160,
        height: 130,
        onClick: async () => {
          sounds.sfx.play('ok');
          opts.close(emoteId);
        },
        tracking: {
          feature: Feature.MATCH2.TEAM.POPUP_EMOTES,
          $subFeature: emoteId,
        },
      });

      new ImageScaleView({
        superview: button,
        width: 120,
        height: 100,
        x: 75,
        y: 75,
        image: `assets/ui/match2/team/chat/emote/${emoteId}.png`,
        centerOnOrigin: true,
      });
    }

    // anchor elements
    createEmitter(this.root, ({ ui }) => ui.screenSize).addListener(
      (screen) => {
        this.panel.updateOpts({
          opacity: 1,
          y: screen.bottom - PANEL_HEIGHT,
        });

        this.bg.updateOpts({
          width: screen.width,
          height: screen.height,
        });
      },
    );
  }

  protected getAssetsGroup() {
    return new AssetGroup(['assets/ui/match2/team/chat/panel_emoteBar.png']);
  }

  public async fadeIn() {
    this.overlay.show();
    this.attachRoot();

    this.bg.updateOpts({ opacity: 0 });

    this.panel.updateOpts({
      offsetY: PANEL_HEIGHT,
    });

    animate(this.panel)
      .clear()
      .then({ offsetY: 0 }, animDuration, animate.easeOut)
      .then(() => this.overlay.hide());
  }

  public fadeOut() {
    this.overlay.show();

    animate(this.bg)
      .clear()
      .wait(animDuration)
      .then({ opacity: 0 }, animDuration, animate.easeOut)
      .then(() => {
        this.detachRoot();
        this.overlay.hide();
      });

    animate(this.panel)
      .clear()
      .then({ offsetY: PANEL_HEIGHT }, animDuration, animate.easeOut);
  }

  public init(opts: {}) {
    super.init(opts);
  }
}
